import React from 'react';
import { Monitor, Users, ArrowUp, X } from 'lucide-react';
import './VideoModeSelector.css';

interface VideoModeOption {
  id: string;
  title: string;
  icon: React.ReactNode;
}

interface VideoModeSelectorProps {
  onSelect: (value: string, shouldAutoAdvance?: boolean) => void;
}

// Video mode icons
const PresenterModeIcon = () => (
  <div className="video-mode-icon">
    <Monitor size={32} strokeWidth={1.5} />
  </div>
);

const GroupModeIcon = () => (
  <div className="video-mode-icon">
    <Users size={32} strokeWidth={1.5} />
  </div>
);

const MixModeIcon = () => (
  <div className="video-mode-icon">
    <ArrowUp size={32} strokeWidth={1.5} />
  </div>
);

const NotSureIcon = () => (
  <div className="video-mode-icon">
    <X size={32} strokeWidth={1.5} />
  </div>
);

const videoModeOptions: VideoModeOption[] = [
  {
    id: 'presenter',
    title: 'Presenter mode',
    icon: <PresenterModeIcon />
  },
  {
    id: 'group',
    title: 'Group mode',
    icon: <GroupModeIcon />
  },
  {
    id: 'mix',
    title: 'A mix of both',
    icon: <MixModeIcon />
  },
  {
    id: 'not-sure',
    title: "I'm not sure",
    icon: <NotSureIcon />
  }
];

// Map video mode types to quiz values
const mapVideoModeToQuizValue = (videoModeType: string): string => {
  switch (videoModeType) {
    case 'presenter':
      return 'Presenter Mode';
    case 'group':
      return 'Group Mode';
    case 'mix':
      return 'Mixed Mode';
    case 'not-sure':
      return 'Not Sure';
    default:
      return 'Not Sure';
  }
};

export const VideoModeSelector: React.FC<VideoModeSelectorProps> = ({ onSelect }) => {
  const [selectedMode, setSelectedMode] = React.useState<string | null>(null);

  const handleModeSelect = (modeType: string) => {
    setSelectedMode(modeType);
    const quizValue = mapVideoModeToQuizValue(modeType);
    onSelect(quizValue);
  };

  return (
    <div className="video-mode-selector">
      <div className="video-mode-options-grid">
        {videoModeOptions.map((option) => (
          <button
            key={option.id}
            className={`video-mode-option-card ${selectedMode === option.id ? 'selected' : ''}`}
            onClick={() => handleModeSelect(option.id)}
            disabled={selectedMode !== null}
          >
            {option.icon}
            <h3 className="video-mode-option-title">{option.title}</h3>
          </button>
        ))}
      </div>
    </div>
  );
};
